import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

const useLocations = ({ storeId }) => {
  const {
    data,
    loading: fetchingLocations,
    fetchData,
  } = useFetch(() => configurationServices.getLocations({ storeId }), {
    doInitialRequest: true,
  })

  return {
    locations: data,
    fetchingLocations,
    refetchLocations: fetchData,
  }
}

export default useLocations
